export default __webpack_public_path__ + "b0251af63130fbd3e7d6459cabf111fd.png";